import { Component, computed, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { UserApplications } from '@workspace/data-types';
import { environment } from '@workspace/ng-config';
import { ApplicationStore, UserStore } from '@workspace/ng-data-access';

export interface AppMenuItem {
  id: string;
  label: string;
  icon: string;
  url: string;
}

@Component({
  selector: 'aura-apps-menu-button',
  imports: [MatIconButton, MatIcon, MatMenu, MatMenuTrigger],
  templateUrl: './apps-menu-button.component.html',
})
export class AppsMenuButtonComponent {
  private readonly appStore = inject(ApplicationStore);
  private readonly userStore = inject(UserStore);
  protected readonly appLinks = environment.apps;

  protected readonly currentApp = computed(() => this.appStore.currentApplicationName());

  protected readonly apps = computed<AppMenuItem[]>(() => {
    const list: (AppMenuItem | null)[] = [
      this.userStore.isAdmin()
        ? {
            id: UserApplications.ADMIN,
            label: 'Admin',
            icon: 'shield',
            url: this.appLinks?.adminUrl,
          }
        : null,
      {
        id: UserApplications.PUBLIC,
        label: 'Public',
        icon: 'globe',
        url: this.appLinks?.publicUrl,
      },
      {
        id: UserApplications.OWNER,
        label: 'Propriétaire',
        icon: 'house',
        url: this.appLinks?.ownerUrl,
      },
      {
        id: UserApplications.AGENT,
        label: 'Agent',
        icon: 'briefcase',
        url: this.appLinks?.agentUrl,
      },
      {
        id: 'zammad',
        label: 'Support',
        icon: 'life-buoy',
        url: this.appLinks?.zammadUrl,
      },
    ];

    return list.filter((app): app is AppMenuItem => !!app && !!app.url);
  });
}
